module.exports = __webpack_public_path__ + "static/media/pfsense_package_manager.4e8bbf37.png";